import Cookies            from "js-cookie";
import { v1 }             from "uuid";
import sha256             from "./sha256";
import { createAuthData } from "_services/api/user";

const DEVICE_ID_KEY = "rooter_pwa_uuid";
const USER_DATA_KEY = "user_auth";

const getSHA256String = elements => {
	return sha256 ( elements.join ( "" ) );
};

const storeUserDataCookie = data => {
	const __data = {
		accessToken : data.accessToken,
		userId      : data.userId,
		isNew       : data.isNew,
		locale      : data.locale
	};

	if ( process.browser ) {
		storeUserData ( __data );
	}

	return {
		...__data,
		deviceId: data.deviceId
	};
};

const USER_LOGIN_REQUEST = {
	pushId   : "webPushId",
	locale   : "en",
	campaign : "webCampaign"
};

const getDeviceId = () => {
	if ( !process.browser )
		return v1 ();

	const cookieData = Cookies.get ( DEVICE_ID_KEY );

	if ( cookieData && cookieData !== "undefined" )
		return cookieData;

	return storeDeviceId ();
};

const createAuthToken = data => {
	const uuid      = getDeviceId ();
	const appSecret = process.env.APP_SECRET_KEY;
	const appEnv    = process.env.APP_ENV;
	const __string  = [ appSecret[appEnv], uuid, JSON.stringify ( data || USER_LOGIN_REQUEST ), appSecret[appEnv] ];
	const authToken = getSHA256String ( __string );

	return {
		deviceId      : uuid,
		customHeaders : {
			deviceId : uuid,
			token    : authToken
		}
	};
};

const checkFirstAndLastName = value => {
	let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;

	return regName.test ( value );
};

const getUserData = () => {
	const userDataFromCookies = Cookies.get ( USER_DATA_KEY );

	if ( !userDataFromCookies )
		return {};

	const data = JSON.parse ( userDataFromCookies );

	return data;
};

const storeDeviceId = deviceId => {
	// Creating a new uuid
	if ( !deviceId )
		deviceId = v1 ();

	Cookies.set ( DEVICE_ID_KEY, deviceId, { expires: 365 } );

	return deviceId;
};

const storeUserData = userAuth => {
	Cookies.set ( USER_DATA_KEY, JSON.stringify ( userAuth ), { expires: 365 } );

	return userAuth;
};

const clearUserData = () => {
	// Need to clear device id as well
	// right now backend is mapping user with this id
	Cookies.remove ( DEVICE_ID_KEY );
	Cookies.remove ( USER_DATA_KEY );

	return;
};

const ssrAuthValidation = async context => {
	const cookies         = context.req.cookies;
	const userAuth        = cookies?.user_auth && JSON.parse ( cookies?.user_auth ) || {};
	const deviceId        = cookies?.rooter_pwa_uuid;
	const { accessToken } = userAuth;

	if ( !accessToken ) {
		const __data = await createAuthData ();

		return {
			auth: {
				userAuth : { accessToken: __data.accessToken },
				deviceId : __data.deviceId
			},
			customHeaders: {
				deviceId : __data.deviceId,
				token    : __data.accessToken
			},
			theme: {
				darkMode: cookies.darkMode === "false" ? false : true
			}
		};
	}

	return {
		customHeaders: {
			deviceId : deviceId,
			token    : accessToken
		},
		theme: {
			darkMode: cookies.darkMode === "false" ? false : true
		}

	};
};

const storeAuthDataClient = async data => {
	const { userAuth, deviceId } = data;

	storeDeviceId ( deviceId );
	storeUserData ( userAuth );
};

export {
	getDeviceId,
	getUserData,
	getSHA256String,
	USER_LOGIN_REQUEST,
	ssrAuthValidation,
	storeUserDataCookie,
	storeAuthDataClient,
	createAuthToken,
	clearUserData,
	checkFirstAndLastName
};
